<template>
  <div
    v-if="filtersSorted.length"
    :class="{ mobile: mobile }"
    class="filters-panel"
  >
    <template v-if="!mobilePortrait && filters.length > 2">
      <v-layout class="d-flex" row>
        <div class="ml-auto mr-2">
          <v-btn
            :disabled="!filtersAreEmpty"
            icon
            @click="clearFilters"
          >
            <v-icon dark>replay</v-icon>
          </v-btn>
        </div>
      </v-layout>
    </template>
    <filter-controls
      v-model="filterValues"
      :filters="commonFilters"
      :validators="filterCheckers"
    />
    <div ref="extendedControls" class="hidden_controls">
      <filter-controls
        v-model="filterValues"
        :filters="extendedFilters"
        :validators="filterCheckers"
      />
    </div>
    <v-btn
      v-if="extendedFilters.length"
      class="toggleHidden"
      text
      @click="toggleExtended"
    >
      {{ $t(extended ? 'Show_more' : 'Show_less') }}

      <v-icon right>
        {{ extended ? 'expand_more' : 'expand_less' }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FilterControls from '@/components/FilterControls.vue';

const COMMON_FILTER_NUMBER = 3;

export default {
  name: 'UnitListFilter',
  components: {
    FilterControls,
  },
  props: {
    plain: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      extended: true,
    };
  },
  created() {
    this.$store.dispatch('filters/load', { order: this.$route.params.order });
  },
  computed: {
    ...mapGetters('filters', ['filterCheckers', 'filtersSorted', 'activeFilters']),
    ...mapGetters('service', ['mobilePortrait']),
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    filters() {
      return this.filtersSorted
        .map(filter => this.createViewObject(filter))
        .filter(v => v);
    },
    lastCommonFilterIndex() {
      return this.plain ? this.filters.length : COMMON_FILTER_NUMBER;
    },
    commonFilters() {
      // returns first N filters
      return this.filters.slice(0, this.lastCommonFilterIndex);
    },
    extendedFilters() {
      // returns last (after N) filters
      return this.filters.slice(this.lastCommonFilterIndex);
    },
    filterValues: {
      get() {
        return this.activeFilters;
      },
      set(value) {
        this.$emit('filtering');
        this.addFilter(value);
      },
    },
  },
  methods: {
    ...mapActions('filters', ['clearFilters', 'addFilter']),
    ...mapGetters('filters', ['filtersAreEmpty']),
    toggleExtended() {
      this.extended = !this.extended;

      const { extendedControls: collapsable } = this.$refs;

      if (this.extended) {
        collapsable.style.overflow = 'hidden';
        collapsable.style.height = '0px';
      } else {
        const innerHeight = collapsable.querySelector('.layout').offsetHeight;

        collapsable.style.height = `${innerHeight}px`;

        setTimeout(() => (collapsable.style.overflow = 'visible'), 400);
      }
    },
    createViewObject(filter) {
      const {
        component, name, label, options, key,
      } = filter;

      return this.filterCheckers.isValidControl(filter.component)
        ? {
          component,
          name,
          label,
          options,
          key,
          // eslint-disable-next-line no-nested-ternary
          value: this.filterCheckers.isSlider(component)
            ? [options.min || 0, options.max]
            : this.filterCheckers.isSingleCheckBox(component)
              ? []
              : null,
        }
        : undefined;
    },
  },
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.filters-panel {
  padding: 10px 0 10px;

  &.mobile {
    @supports (padding-left: env(safe-area-inset-left)) {
      padding-left: env(safe-area-inset-left) !important;
      padding-right: env(safe-area-inset-right) !important;
    }

    .filter_columns:not(:first-child) {
      margin-top: 12px;
    }
  }

  .filter_columns {
    padding: 0 24px;
  }

  .filter_input_centered {
    position: relative;
    top: 20px;

    input {
      text-align: center;

      &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  .v-input--slider {
    position: relative;
    top: 20px;
  }

  .toggleHidden {
    margin-top: 15px;
    margin-left: 8px;
  }

  .row {
    margin-left: 0;
    margin-right: 0;
  }

  &.mobile .row {
    width: 100%;
  }

  .hidden_controls {
    transition: height 400ms;
    overflow: hidden;
    height: 0;
  }

  &.mobile .v-input {
    // width: calc(32% - 8px);
    margin-top: 12px !important;

    //.mdi-checkbox-blank-outline::before {
    //  border: 1px solid #acacac;
    //}
  }
}
</style>
